// import React, { useState, useEffect } from 'react';
// import api from '../api/api';
// const ProductManager = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [currentProductId, setCurrentProductId] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [productData, setProductData] = useState({
//     lineItemName: '',
//     category: '',
//     subCategory: '',
//     isActive: true,
//     addInSpin: false,
//     gender: 'male'
//   });

//   // ─── CORRECT URLs ────────────────────────────────────────────────

//   const BASE_URL    = api ? api.defaults.baseURL || '' : '';  // Dynamically get base URL from api instance
//   const API_URL     = `${BASE_URL}/api/products`;          // GET list
//   const ADD_URL     = `${BASE_URL}/api/products/add`;      // POST new
//   const UPDATE_URL  = (id) => `${BASE_URL}/api/products/update/${id}`;  // PUT
//   const DELETE_URL  = (id) => `${BASE_URL}/api/products/delete/${id}`;  // DELETE

//   const menuData = {
//     "Mens Footwear": {
//       "Casual": ["Sneakers", "Loafers", "Sandals"],
//       "Formal": ["Oxford", "Derby", "Monk Strap"]
//     },
//     "Womens Footwear": {
//       "Flats": ["Ballerinas", "Mules"],
//       "Heels": ["Stilettos", "Block Heels", "Kitten Heels"]
//     },
//     "Accessories": {
//       "Leather Accessories": ["Belts", "Wallets", "Card Holders", "Purse"]
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//   }, );

//   const fetchProducts = async () => {
//     try {
//       // for admin panel product
//       const res = await api.get(API_URL);
//       setProducts(res.data);
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     }
//   };

//   const handleEditClick = (product) => {
//     setIsEditing(true);
//     setCurrentProductId(product.id);
//     setProductData({
//       lineItemName: product.lineItemName,
//       category:     product.category,
//       subCategory:  product.subCategory,
//       isActive:     product.isActive,
//       addInSpin:    product.addInSpin,
//       gender:       product.gender || 'male'
//     });
//     setIsModalOpen(true);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this product?")) {
//       try {
//         await api.delete(DELETE_URL(id));
//         fetchProducts();
//       } catch (err) {
//         alert("Delete failed: " + err.message);
//       }
//     }
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsEditing(false);
//     setCurrentProductId(null);
//     setProductData({
//       lineItemName: '',
//       category:     '',
//       subCategory:  '',
//       isActive:     true,
//       addInSpin:    false,
//       gender:       'male'
//     });
//   };

//   const handleProductSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (isEditing) {
//         // ── EDIT: PUT /api/products/update/:id ──────────────────────
//         await api.put(UPDATE_URL(currentProductId), productData);
//         alert("Product Updated Successfully!");
//       } else {
//         // ── ADD NEW: POST /api/products/add ─────────────────────────
//         await api.post(ADD_URL, productData);
//         alert("Product Saved to Database!");
//       }
//       fetchProducts();
//       closeModal();
//     } catch (error) {
//       alert("Error saving: " + (error.response?.data?.error || error.message));
//     }
//   };

//   return (
//     <div className="p-8 max-w-6xl mx-auto">
//       <div className="flex justify-between items-center mb-8 bg-white p-4 rounded-lg shadow-sm border">
//         <h2 className="text-2xl font-bold text-slate-800">Product Management</h2>
//         <button
//           onClick={() => { setIsEditing(false); setIsModalOpen(true); }}
//           className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700 transition-all font-semibold"
//         >
//           <span className="text-xl">+</span> Add New Item
//         </button>
//       </div>

//       {/* ── PRODUCT TABLE ──────────────────────────────────────────── */}
//       <div className="bg-white rounded-xl shadow-md border overflow-hidden">
//         <table className="w-full text-left">
//           <thead className="bg-gray-50 border-b">
//             <tr>
//               <th className="p-4">Line Item</th>
//               <th className="p-4">Category</th>
//               <th className="p-4">Sub-Category</th>
//               <th className="p-4 text-center">Gender</th>
//               <th className="p-4 text-center">Status</th>
//               <th className="p-4 text-center">Spin Wheel</th>
//               <th className="p-4">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {products.length > 0 ? products.map((p) => (
//               <tr key={p.id} className="border-b hover:bg-gray-50">
//                 <td className="p-4 font-medium">{p.lineItemName}</td>
//                 <td className="p-4 text-gray-600">{p.category}</td>
//                 <td className="p-4 text-gray-600">{p.subCategory}</td>
//                 <td className="p-4 text-center">
//                   {p.gender === 'male'
//                     ? <span className="text-blue-600 font-semibold">♂ Male</span>
//                     : p.gender === 'female'
//                       ? <span className="text-pink-600 font-semibold">♀ Female</span>
//                       : '—'}
//                 </td>
//                 <td className="p-4 text-center">
//                   <span className={`px-2 py-1 rounded text-xs font-bold ${p.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//                     {p.isActive ? 'ACTIVE' : 'INACTIVE'}
//                   </span>
//                 </td>
//                 <td className="p-4 text-center">{p.addInSpin ? '✅' : '❌'}</td>
//                 <td className="p-4">
//                   <button onClick={() => handleEditClick(p)} className="text-blue-600 font-semibold mr-3 hover:text-blue-800">Edit</button>
//                   <button onClick={() => handleDelete(p.id)} className="text-red-600 font-semibold hover:text-red-800">Delete</button>
//                 </td>
//               </tr>
//             )) : (
//               <tr>
//                 <td colSpan="7" className="p-10 text-center text-gray-400">No products found. Add your first item!</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ── ADD / EDIT MODAL ───────────────────────────────────────── */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl">
//             <div className="bg-blue-600 p-4 flex justify-between items-center text-white rounded-t-2xl">
//               <h3 className="font-bold text-lg">{isEditing ? 'Edit Product' : 'Add New Product'}</h3>
//               <button onClick={closeModal} className="text-2xl leading-none">×</button>
//             </div>

//             <form onSubmit={handleProductSubmit} className="p-6">
//               <div className="grid grid-cols-2 gap-4">

//                 {/* Line Item */}
//                 <div>
//                   <label className="text-sm font-semibold block mb-1">Line Item</label>
//                   <input
//                     list="lineItems"
//                     required
//                     placeholder="e.g. Mens Footwear"
//                     className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     value={productData.lineItemName}
//                     onChange={e => setProductData({ ...productData, lineItemName: e.target.value })}
//                   />
//                   <datalist id="lineItems">
//                     {Object.keys(menuData).map(item => <option key={item} value={item} />)}
//                   </datalist>
//                 </div>

//                 {/* Category */}
//                 <div>
//                   <label className="text-sm font-semibold block mb-1">Category</label>
//                   <input
//                     list="categories"
//                     required
//                     placeholder="e.g. Casual"
//                     className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     value={productData.category}
//                     onChange={e => setProductData({ ...productData, category: e.target.value })}
//                   />
//                   <datalist id="categories">
//                     {productData.lineItemName && menuData[productData.lineItemName] &&
//                       Object.keys(menuData[productData.lineItemName]).map(cat => <option key={cat} value={cat} />)}
//                   </datalist>
//                 </div>

//                 {/* Sub-Category */}
//                 <div className="col-span-2">
//                   <label className="text-sm font-semibold block mb-1">Sub-Category</label>
//                   <input
//                     list="subCategories"
//                     required
//                     placeholder="e.g. Sneakers"
//                     className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     value={productData.subCategory}
//                     onChange={e => setProductData({ ...productData, subCategory: e.target.value })}
//                   />
//                   <datalist id="subCategories">
//                     {productData.lineItemName && menuData[productData.lineItemName] &&
//                      productData.category && menuData[productData.lineItemName][productData.category] &&
//                       menuData[productData.lineItemName][productData.category].map(sub => <option key={sub} value={sub} />)}
//                   </datalist>
//                 </div>
//               </div>

//               {/* Gender Selection */}
//               <div className="mt-4 flex gap-4 items-center">
//                 <span className="text-sm font-semibold">Gender:</span>
//                 <button
//                   type="button"
//                   onClick={() => setProductData({ ...productData, gender: 'male' })}
//                   className={`px-4 py-2 rounded-full font-semibold transition-all ${
//                     productData.gender === 'male'
//                       ? 'bg-blue-600 text-white shadow-md'
//                       : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                   }`}
//                 >
//                   ♂ Male
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => setProductData({ ...productData, gender: 'female' })}
//                   className={`px-4 py-2 rounded-full font-semibold transition-all ${
//                     productData.gender === 'female'
//                       ? 'bg-pink-600 text-white shadow-md'
//                       : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                   }`}
//                 >
//                   ♀ Female
//                 </button>
//               </div>

//               {/* Active & Spin checkboxes */}
//               <div className="mt-6 flex gap-6 bg-gray-50 p-4 rounded-lg border">
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     checked={productData.isActive}
//                     onChange={e => setProductData({ ...productData, isActive: e.target.checked })}
//                   />
//                   Active
//                 </label>
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     checked={productData.addInSpin}
//                     onChange={e => setProductData({ ...productData, addInSpin: e.target.checked })}
//                   />
//                   Add in Spin
//                 </label>
//               </div>

//               {/* Buttons */}
//               <div className="mt-8 flex gap-3">
//                 <button
//                   type="button"
//                   onClick={closeModal}
//                   className="flex-1 bg-gray-200 py-3 rounded-xl font-bold hover:bg-gray-300 transition-all"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="flex-1 bg-blue-600 text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-all"
//                 >
//                   Save Info
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProductManager;












import React, { useCallback, useEffect, useState } from 'react';
import api from '../api/api';

const EMPTY_PRODUCT = {
  lineItemName: '',
  category: '',
  subCategory: '',
  isActive: true,
  addInSpin: false,
  gender: 'male'
};

const ProductManager = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentProductId, setCurrentProductId] = useState(null);
  const [products, setProducts] = useState([]);
  const [productData, setProductData] = useState({ ...EMPTY_PRODUCT });

  const baseUrl = (api?.defaults?.baseURL || '').replace(/\/+$/, '');
  const apiUrl = `${baseUrl}/api/products`;
  const addUrl = `${apiUrl}/add`;
  const updateUrl = (id) => `${apiUrl}/update/${id}`;
  const deleteUrl = (id) => `${apiUrl}/delete/${id}`;

  const menuData = {
    'Mens Footwear': {
      Casual: ['Sneakers', 'Loafers', 'Sandals'],
      Formal: ['Oxford', 'Derby', 'Monk Strap']
    },
    'Womens Footwear': {
      Flats: ['Ballerinas', 'Mules'],
      Heels: ['Stilettos', 'Block Heels', 'Kitten Heels']
    },
    Accessories: {
      'Leather Accessories': ['Belts', 'Wallets', 'Card Holders', 'Purse']
    }
  };

  const fetchProducts = useCallback(async () => {
    try {
      const res = await api.get(apiUrl);
      setProducts(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Error fetching products:', err);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const openAddModal = () => {
    setIsEditing(false);
    setCurrentProductId(null);
    setProductData({ ...EMPTY_PRODUCT });
    setIsModalOpen(true);
  };

  const handleEditClick = (product) => {
    setIsEditing(true);
    setCurrentProductId(product.id);
    setProductData({
      lineItemName: product.lineItemName ?? '',
      category: product.category ?? '',
      subCategory: product.subCategory ?? '',
      isActive: product.isActive ?? true,
      addInSpin: product.addInSpin ?? false,
      gender: product.gender || 'male'
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEditing(false);
    setCurrentProductId(null);
    setProductData({ ...EMPTY_PRODUCT });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this product?')) return;

    try {
      await api.delete(deleteUrl(id));
      await fetchProducts();
    } catch (err) {
      alert('Delete failed: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleProductSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      ...productData,
      // Empty values are deliberately sent as empty strings. Any one field
      // (line item, category, or sub-category) can be saved by itself.
      lineItemName: String(productData.lineItemName ?? '').trim(),
      category: String(productData.category ?? '').trim(),
      subCategory: String(productData.subCategory ?? '').trim()
    };

    try {
      if (isEditing) {
        await api.put(updateUrl(currentProductId), payload);
        alert('Product Updated Successfully!');
      } else {
        await api.post(addUrl, payload);
        alert('Product Saved to Database!');
      }

      await fetchProducts();
      closeModal();
    } catch (err) {
      alert('Error saving: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-8 bg-white p-4 rounded-lg shadow-sm border">
        <h2 className="text-2xl font-bold text-slate-800">Product Management</h2>
        <button
          type="button"
          onClick={openAddModal}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700 transition-all font-semibold"
        >
          <span className="text-xl">+</span> Add New Item
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="p-4">Line Item</th>
              <th className="p-4">Category</th>
              <th className="p-4">Sub-Category</th>
              <th className="p-4 text-center">Gender</th>
              <th className="p-4 text-center">Status</th>
              <th className="p-4 text-center">Spin Wheel</th>
              <th className="p-4">Action</th>
            </tr>
          </thead>
          <tbody>
            {products.length > 0 ? products.map((product) => (
              <tr key={product.id} className="border-b hover:bg-gray-50">
                <td className="p-4 font-medium">{product.lineItemName || '—'}</td>
                <td className="p-4 text-gray-600">{product.category || '—'}</td>
                <td className="p-4 text-gray-600">{product.subCategory || '—'}</td>
                <td className="p-4 text-center">
                  {product.gender === 'male'
                    ? <span className="text-blue-600 font-semibold">♂ Male</span>
                    : product.gender === 'female'
                      ? <span className="text-pink-600 font-semibold">♀ Female</span>
                      : '—'}
                </td>
                <td className="p-4 text-center">
                  <span className={`px-2 py-1 rounded text-xs font-bold ${product.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    {product.isActive ? 'ACTIVE' : 'INACTIVE'}
                  </span>
                </td>
                <td className="p-4 text-center">{product.addInSpin ? '✅' : '❌'}</td>
                <td className="p-4">
                  <button type="button" onClick={() => handleEditClick(product)} className="text-blue-600 font-semibold mr-3 hover:text-blue-800">Edit</button>
                  <button type="button" onClick={() => handleDelete(product.id)} className="text-red-600 font-semibold hover:text-red-800">Delete</button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="7" className="p-10 text-center text-gray-400">No products found. Add your first item!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl">
            <div className="bg-blue-600 p-4 flex justify-between items-center text-white rounded-t-2xl">
              <h3 className="font-bold text-lg">{isEditing ? 'Edit Product' : 'Add New Product'}</h3>
              <button type="button" onClick={closeModal} className="text-2xl leading-none" aria-label="Close">×</button>
            </div>

            <form onSubmit={handleProductSubmit} className="p-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-semibold block mb-1">Line Item </label>
                  <input
                    list="lineItems"
                    placeholder="e.g. Mens Footwear"
                    className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={productData.lineItemName}
                    onChange={(event) => setProductData({ ...productData, lineItemName: event.target.value })}
                  />
                  <datalist id="lineItems">
                    {Object.keys(menuData).map((item) => <option key={item} value={item} />)}
                  </datalist>
                </div>

                <div>
                  <label className="text-sm font-semibold block mb-1">Category </label>
                  <input
                    list="categories"
                    placeholder="e.g. Casual"
                    className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={productData.category}
                    onChange={(event) => setProductData({ ...productData, category: event.target.value })}
                  />
                  <datalist id="categories">
                    {productData.lineItemName && menuData[productData.lineItemName] &&
                      Object.keys(menuData[productData.lineItemName]).map((category) => <option key={category} value={category} />)}
                  </datalist>
                </div>

                <div className="col-span-2">
                  <label className="text-sm font-semibold block mb-1">Sub-Category </label>
                  <input
                    list="subCategories"
                    placeholder="e.g. Sneakers"
                    className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={productData.subCategory}
                    onChange={(event) => setProductData({ ...productData, subCategory: event.target.value })}
                  />
                  <datalist id="subCategories">
                    {productData.lineItemName && menuData[productData.lineItemName] && productData.category && menuData[productData.lineItemName][productData.category] &&
                      menuData[productData.lineItemName][productData.category].map((subCategory) => <option key={subCategory} value={subCategory} />)}
                  </datalist>
                </div>
              </div>

              <div className="mt-4 flex gap-4 items-center">
                <span className="text-sm font-semibold">Gender:</span>
                <button
                  type="button"
                  onClick={() => setProductData({ ...productData, gender: 'male' })}
                  className={`px-4 py-2 rounded-full font-semibold transition-all ${productData.gender === 'male' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  ♂ Male
                </button>
                <button
                  type="button"
                  onClick={() => setProductData({ ...productData, gender: 'female' })}
                  className={`px-4 py-2 rounded-full font-semibold transition-all ${productData.gender === 'female' ? 'bg-pink-600 text-white shadow-md' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  ♀ Female
                </button>
              </div>

              <div className="mt-6 flex gap-6 bg-gray-50 p-4 rounded-lg border">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={Boolean(productData.isActive)}
                    onChange={(event) => setProductData({ ...productData, isActive: event.target.checked })}
                  />
                  Active
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={Boolean(productData.addInSpin)}
                    onChange={(event) => setProductData({ ...productData, addInSpin: event.target.checked })}
                  />
                  Add in Spin
                </label>
              </div>

              <div className="mt-8 flex gap-3">
                <button type="button" onClick={closeModal} className="flex-1 bg-gray-200 py-3 rounded-xl font-bold hover:bg-gray-300 transition-all">
                  Cancel
                </button>
                <button type="submit" className="flex-1 bg-blue-600 text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-all">
                  Save Info
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductManager;
